// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Grid } from '../../../lib/base';

export default React.memo(function UnitsInputContainer({
  input,
  units,
}: {
  readonly input: React.ReactElement;
  readonly units: React.ReactElement;
}) {
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm>
        {input}
      </Grid>
      <Grid xs={12} sm="auto">
        {units}
      </Grid>
    </Grid>
  );
});
